import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import * as actions from '../actions';
// import ViewSOA from './ViewSOA';

const INIT_STATE = {
  amount: 0,
  code: 'DISC',
  description: 'DISCOUNT',
};

function ApplyDiscountModal({
  // handleApplyDiscount,
  // generateSOA,
  // item,
  originalAmount,
  discount,
  amount,
  applyDiscount,
  id,
  code,
  description,
  // getItem,
  handleGenerateSOA,
  permissions,
}) {
  const setModal = useContext(ModalContext);
  const [payload, setPayload] = useState(INIT_STATE);

  useEffect(() => {
    setPayload((prev) => ({
      ...prev,
      amount: discount,
      ...(code && { code }),
      ...(description && { description }),
    }));

    return () => {
      setPayload({});
    };
  }, [discount]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    const regex = /^(\d*\.\d{0,2}?|^\d+)$/; // Regular expression to match numbers with up to two decimal places

    if (name !== 'discount') {
      setPayload((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    if (regex.test(value) || value === '') {
      setPayload((prev) => ({
        ...prev,
        amount: value,
      }));
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'e' || e.key === 'E') {
      e.preventDefault();
    }
  };

  const handleSubmit = () => {
    applyDiscount(id, payload, () => {
      // getItem(id);
      setModal({ isOpen: false });
      handleGenerateSOA();
      // generateSOA(_.get(item, 'id'), {}, (response) => {
      //   // getItem(_.get(item, 'id'));
      //   setModal({
      //     isOpen: true,
      //     content: (
      //       <ViewSOA
      //         data={item}
      //         generateAmount={response}
      //         handleApplyDiscount={handleApplyDiscount}
      //       />
      //     ),
      //     title: 'View e-SOA',
      //     modalSize: 'modal-xl',
      //   });
      // });
    });
  };

  const handleRemoveDiscount = () => {
    applyDiscount(id, INIT_STATE, () => {
      setModal({ isOpen: false });
      handleGenerateSOA();
    });
  };

  const isInvalid = () => {
    if (!Number(originalAmount)) {
      return Number(payload.amount) > Number(amount);
    }
    return Number(payload.amount) > Number(originalAmount);
  };

  return (
    <Modal.Body>
      <div className="d-flex flex-column">
        <div className="form-group mb-3">
          <label htmlFor="code">Code</label>
          <input
            name="code"
            type="text"
            className="form-control"
            id="code"
            onChange={handleChange}
            value={payload.code}
          />
        </div>

        <div className="form-group mb-3">
          <label htmlFor="description">Description</label>
          <input
            name="description"
            type="text"
            className="form-control"
            id="description"
            onChange={handleChange}
            value={payload.description}
          />
        </div>

        <div className="form-group">
          <label htmlFor="inputDiscount">Discount Amount</label>
          <div className="input-group mb-3">
            <div className="input-group-prepend">
              <span className="input-group-text" id="basic-addon3">
                ₱
              </span>
            </div>
            <input
              name="amount"
              type="number"
              step="0.01"
              className="form-control"
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              value={payload.amount}
              id="amount"
            />
          </div>

          {isInvalid() ? (
            <small className="text-danger form-text">
              Discount cannot be higher than the Amount.
            </small>
          ) : null}
        </div>

        <table className="m-3">
          <tbody>
            <tr>
              <td className="p-2">
                <small style={{ opacity: '0.5' }}>Amount</small>
              </td>
              <td>&nbsp;</td>
              <td className="p-2">₱</td>
              <td className="p-2 text-right">
                {!Number(originalAmount)
                  ? Number(amount).toFixed(2)
                  : Number(originalAmount).toFixed(2)}
              </td>
            </tr>
            <tr>
              <td className="p-2">
                <small style={{ opacity: '0.5' }}>Discount</small>
              </td>
              <td>-</td>
              <td className="p-2">₱</td>
              <td className="p-2 text-right">
                {Number(payload.amount).toFixed(2)}
              </td>
            </tr>
            <tr className="border-top">
              <td className="p-2">
                <small style={{ opacity: '0.5' }}>Discounted Amount</small>
              </td>
              <td>&nbsp;</td>
              <td className="p-2">₱</td>
              <td className="p-2 text-right">
                {!Number(originalAmount)
                  ? (Number(amount) - Number(payload.amount)).toFixed(2)
                  : (Number(originalAmount) - Number(payload.amount)).toFixed(
                      2
                    )}
              </td>
            </tr>
          </tbody>
        </table>

        <div className="d-flex align-items-stretch justify-content-between mt-5">
          {Acl(permissions, ['REMOVE DISCOUNT BPLS']) ? (
            <button
              type="button"
              className="btn btn-sm btn-danger"
              onClick={handleRemoveDiscount}
              disabled={!Number(discount) || Number(discount) <= 0}
            >
              Remove Discount
            </button>
          ) : (
            <div />
          )}

          <div className="d-flex align-items-center justify-content-end">
            <button
              type="button"
              className="btn btn-sm btn-light mr-3"
              onClick={() => setModal({ isOpen: false })}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-sm btn-dark"
              disabled={
                !Number(payload.amount) ||
                (Number(payload.amount) && isInvalid())
              }
              onClick={handleSubmit}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </Modal.Body>
  );
}

ApplyDiscountModal.propTypes = {
  // handleApplyDiscount: PropTypes.instanceOf(Function).isRequired,
  // generateSOA: PropTypes.instanceOf(Function).isRequired,
  // item: PropTypes.instanceOf(Object).isRequired,
  originalAmount: PropTypes.number.isRequired,
  discount: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired,
  applyDiscount: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  handleGenerateSOA: PropTypes.instanceOf(Function).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([
  withForm,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ApplyDiscountModal);
